"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Field_1 = require("./Field");
var TextArea_1 = require("./TextArea");
var hasError = function (error) { return (error !== null && error !== void 0 ? error : "").length > 0; };
var getPaddingForField = function (hasIcon, searchField) {
    return hasIcon ? (searchField ? "pl-8" : "pr-8") : "";
};
exports.TextAreaField = react_1.default.forwardRef(function (_a, forwardedRef) {
    var name = _a.name, placeholder = _a.placeholder, className = _a.className, style = _a.style, disabled = _a.disabled, errorMessage = _a.errorMessage, errors = _a.errors, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, fieldProps = __rest(_a, ["name", "placeholder", "className", "style", "disabled", "errorMessage", "errors", "onChange", "onBlur", "onFocus"]);
    var determinedErrorMessage = (0, Field_1.getErrorMessage)({
        name: name,
        errorMessage: errorMessage,
        errors: errors,
    });
    var hasIcon = typeof fieldProps.icon !== "undefined";
    return ((0, jsx_runtime_1.jsx)(Field_1.Field, __assign({ name: name, className: className, style: style, errorMessage: determinedErrorMessage }, fieldProps, { children: (0, jsx_runtime_1.jsx)(TextArea_1.TextArea, { name: name, placeholder: placeholder, disabled: disabled, error: hasError(determinedErrorMessage), ref: forwardedRef, className: getPaddingForField(hasIcon), onChange: onChange, onFocus: onFocus, onBlur: onBlur }, void 0) }), void 0));
});
exports.TextAreaField.displayName = "Form.TextAreaField";
